import * as SerializerLib from "jsonapi-serializer";

import { serializeError } from "../base.serializer";

const JSONAPISerializer = SerializerLib.Serializer;

const opts = {
  attributes: [
    "name",
    "description",
    "mediaUrl",
    "backgroundColourId",
    "baItemConfigAttributes",
    "categoryId"
  ],
  baItemConfigAttributes: {
    attributes: ["unitCap"]
  }
};

export const serialize = (data: object) => {
  try {
    const Serializer = new JSONAPISerializer("ideas", opts);
    return Serializer.serialize(data);
  } catch (err) {
    return serializeError(err);
  }
};

export const serializeBAContribution = (data: object) => {
  try {
    const Serializer = new JSONAPISerializer("ba_contribution", {
      attributes: ["unitValue"]
    });
    return Serializer.serialize(data);
  } catch (err) {
    return serializeError(err);
  }
};
